import type { Configuration } from "@azure/msal-browser";
import { MsalLayer } from "./msalLayer";

declare module "vue/types/vue" {
    interface Vue {
        $msal: MsalLayer;
    }
}
declare module "vue" {
    interface ComponentCustomProperties {
        $msal: MsalLayer;
    }
}

class MsalPlugin {
    // to annoying to type Vue since it's supporting both vue2 and vue
    static install(Vue: any, options: Configuration): void {
        Vue.prototype.$msal = new MsalLayer(options);
    }
}

export { MsalPlugin, MsalLayer, Configuration };
